import React from "react";
import "./card.styles.scss";

const Card = ({ handle, details }) => {
  const { name, imageUrl } = details;
  return (
    <div className="card" onClick={() => handle(details)}>
      <div
        className="card-image"
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      ></div>
      <div className="card-description">
        <span>{name}</span>
      </div>
    </div>
  );
};

export default Card;
